"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMAGE_STANDARD_WEB_IMAGE_EXTENSIONS = exports.IMAGE_SIGNED_UPLOAD_MAX_BYTES = exports.IMAGE_UPLOAD_MAX_BYTES = exports.IMAGE_SERVER_NORMALIZATION_MIME_TYPES = exports.IMAGE_SERVER_NORMALIZATION_EXTENSIONS = void 0;
/**
 * File extensions that are normalized on the server (HEIC/HEIF/TIFF/BMP → JPEG, etc.).
 * Keep web + Cloud Functions + client upload policy in sync.
 */
exports.IMAGE_SERVER_NORMALIZATION_EXTENSIONS = [
    'heic',
    'heif',
    'tif',
    'tiff',
    'bmp',
];
/** MIME types that imply the same server-side normalization path as the extensions above. */
exports.IMAGE_SERVER_NORMALIZATION_MIME_TYPES = [
    'image/heic',
    'image/heif',
    'image/tiff',
    'image/bmp',
];
/**
 * Hard ceiling the uploadImage Cloud Function enforces on a request body.
 * Gen2 HTTP bodies cap at 32MB; this keeps headroom so an oversized upload is
 * rejected with a readable 413 instead of failing at the infrastructure layer
 * (which returns no CORS headers, so the browser only sees "Failed to fetch").
 * Clients should pre-flight against this so the user gets a real explanation.
 *
 * Python cannot import this, so `restServer/api/views/uploads.py:MAX_UPLOAD_BYTES`
 * carries a hand-kept copy. Change both together.
 */
exports.IMAGE_UPLOAD_MAX_BYTES = 28 * 1024 * 1024;
/**
 * Ceiling for the signed-URL upload path (`uploadMediaInit` -> signed PUT ->
 * `uploadMediaFinalize`), which bypasses the Cloud Functions request body
 * entirely and so is not bound by the gen2 32MB cap above.
 *
 * Decimal, not `100 * 1024 * 1024`: every message that states this limit runs
 * through formatUploadLimit, which is decimal on purpose so it agrees with what
 * the user's OS reports for the same file. A binary ceiling would render as
 * "104.8 MB" in copy that is supposed to say 100 MB. The video ceiling in
 * uploadMediaInit stays binary; that 4.8% gap is not worth changing a shipped
 * limit for.
 *
 * Deliberately separate from IMAGE_UPLOAD_MAX_BYTES: that constant still
 * governs the normalizing POST path and is mirrored by hand in restServer.
 * Raising this one does not affect restServer.
 */
exports.IMAGE_SIGNED_UPLOAD_MAX_BYTES = 100000000;
/** Typical web image extensions accepted alongside server-normalized types in file pickers. */
exports.IMAGE_STANDARD_WEB_IMAGE_EXTENSIONS = [
    'jpg',
    'jpeg',
    'png',
    'webp',
];
